module.exports = __webpack_public_path__ + "img/alert.383814e0.svg";